<template>
  <div class="talent-wrap industry-information-container">
    <div class="talent-body-wrap home-mini-width hom-max-width">
      <TitleCard v-if="showOperation('industry')"
                 title="产业导航"
                 :loading="loading1"
                 :isEmpty="isEmpty1"
                 :type="projectOption.titleCardType"
                 @moreClick="toRouter('IndustryNavigationList')">
        <div class="searchCard">
          <TableCard :tableList="resultList"
                     @moreChange="toDetails"></TableCard>
        </div>
      </TitleCard>
      <TitleCard v-if="showOperation('normal')"
                 title="标准必要专利推送"
                 :loading="loading2"
                 :isEmpty="isEmpty2"
                 :type="projectOption.titleCardType"
                 @moreClick="toRouter('StandardDataList')">
        <div class="searchCard">
          <TableCard :tableList="resultList1"
                     @moreChange="toDetails"></TableCard>
        </div>
      </TitleCard>
      <TitleCard v-if="showOperation('normal')"
                 title="公知公用技术推送"
                 :loading="loading3"
                 :isEmpty="isEmpty3"
                 :type="projectOption.titleCardType"
                 @moreClick="toRouter('PublicTechnologyList')">
        <div class="searchCard">
          <TableCard :tableList="pubTechList"
                     @moreChange="toDetails"></TableCard>
        </div>
      </TitleCard>
      <TitleCard v-if="showOperation('patentInfo')"
                 title="专利信息分析"
                 :loading="loading"
                 :isEmpty="isEmpty"
                 :type="projectOption.titleCardType"
                 @moreClick="showQrcode">
        <div class="searchCard">
          <TableCard :tableList="dataList"
                     @moreChange="patentToDetails"></TableCard>
        </div>
      </TitleCard>
    </div>
    <a-modal :title="title"
             :visible="visible"
             width="1000px"
             :footer="null"
             @cancel="handleCancel">
      <div>
        <iframe :src="pdfUrl"
                width="100%"
                height="600px"
                class="iframeBox"></iframe>
      </div>
    </a-modal>
    <CodeModel v-if="isShowCode"
               @cancel="codeCancel"></CodeModel>
  </div>
</template>

<script>
import TableCard from '@/components/common/tableCard'
import { infoList, standardList, pubTechList } from '@/api/technicalR'
import { Mixin } from './pages/mixins'
import { getIndustryInfo } from '@/api/IpProject'
import { picList } from './configs/config'
import { projectKey } from '@/utils/gettingEnv'
import CodeModel from './pages/components/codeModel'

export default {
  data() {
    return {
      picList,
      loading: false,
      isEmpty: false,
      loading1: false,
      isEmpty1: false,
      loading2: false,
      isEmpty2: false,
      loading3: false,
      isEmpty3: false,
      resultList: [],
      resultList1: [],
      pubTechList: [],
      searchParams: {
        industry: '',
        expertsType: '',
        pageSize: 10,
        pageNum: 1,
      },
      infoParams: {
        pageSize: 3,
        pageNum: 1,
        status: 1,
      },
      dataList: [],
      isShowCode: false,

      // 项目配置
      projectOption: {
        titleCardType: 'firstCard', // 默认广州卡片是这个type
        showCardNames: ['industry', 'normal', 'patentInfo'], // 卡片显示判断，如果名字在其中才会回显。默认广州是全部回显
      },
    }
  },
  mixins: [Mixin],
  components: {
    TableCard,
    CodeModel,
  },
  computed: {
    projectKey() {
      return projectKey()
    },
  },
  mounted() {
    this.switchOperationFromDiffProject()
    this.init()
  },
  methods: {
    // 卡片是否回显
    showOperation(cardName) {
      return this.projectOption.showCardNames.includes(cardName)
    },
    // 根据项目判断模块回显
    switchOperationFromDiffProject() {
      switch (this.projectKey) {
        case 'zhongshan':
          if (process.env.VUE_APP_OPERATION_VISIBLE) {
            const { showCardNames, titleCardType, patentStaticImg } =
              process.env.VUE_APP_OPERATION_VISIBLE.IndustryInformation
            this.picList = Object.values(patentStaticImg)
            this.projectOption = {
              titleCardType,
              showCardNames: Object.values(showCardNames),
            }
          }
          break

        default:
          // 默认是广州项目
          break
      }
    },
    // 请求产业
    async requestIndustryList() {
      this.loading1 = true
      this.loading2 = true
      this.loading = true
      let data = await infoList(this.infoParams)
      this.loading1 = false
      this.isEmpty1 = data.rows.length === 0
      this.resultList = data.rows
      this.resultList.forEach((item) => {
        item.img = this.getUrl(item)
      })
    },
    // 请求标准
    async requestNormalList() {
      let data1 = await standardList(this.infoParams)
      this.loading2 = false
      this.isEmpty2 = data1.rows.length === 0
      this.resultList1 = data1.rows
      this.resultList1.forEach((item) => {
        item.img = this.getUrl(item)
      })
    },
    // 请求公知
    async requestPubTechList() {
      let data1 = await pubTechList(this.infoParams)
      this.loading3 = false
      this.isEmpty3 = data1.rows.length === 0
      this.pubTechList = data1.rows
      this.pubTechList.forEach((item) => {
        item.img = this.getUrl(item)
      })
    },
    // 请求专利信息
    async requestPatentList() {
      let id = process.env.VUE_APP_OFFICE_ID
      let params = {
        pageNum: 1,
        pageSize: 3,
        id: id,
      }
      if (this.projectKey === 'zhongshan') {
        params = {
          pageNum: 1,
          pageSize: 5,
          id: id,
        }
      }
      let res = await getIndustryInfo(params)
      this.loading = false
      this.isEmpty = res.total === 0
      this.dataList = res.data.reduce((pre, item, index) => {
        item = {
          ...item,
          img: this.picList[index],
        }
        pre.push(item)
        return pre
      }, [])
    },
    async init() {
      // 产业导航
      this.showOperation('industry') && this.requestIndustryList()
      this.showOperation('normal') && this.requestNormalList()
      this.showOperation('normal') && this.requestPubTechList()
      this.showOperation('patentInfo') && this.requestPatentList()
    },
    showQrcode() {
      this.isShowCode = true
    },
    getUrl(item) {
      if (item.fileVo !== null && item.fileVo.length > 0) {
        return item.fileVo[0].filePath
      } else {
        return ''
      }
    },
    codeCancel() {
      this.isShowCode = false
    },
    toRouter(router, params) {
      this.$router.push({ name: router, query: { ...params } })
    },
    // 跳转详情
    toDetail(uid) {
      this.$router.push({ name: 'talentDetail', query: { uid } })
    },
    patentToDetails(item) {
      this.$router.push({
        path: `/IndustryInformation/List?id=${item.id}&name=${item.name}`,
      })
    },
  },
}
</script>
<style scoped>
.infos-wrap {
  display: inline-block;
}
</style>
